import { render } from "./Index.vue?vue&type=template&id=49914f46&scoped=true"
import script from "./Index.vue?vue&type=script&setup=true&lang=js"
export * from "./Index.vue?vue&type=script&setup=true&lang=js"

import "./Index.vue?vue&type=style&index=0&id=49914f46&scoped=true&lang=css"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49914f46"],['__file',"resources/js/modules/product-mapping-tool/components/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "49914f46"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('49914f46', __exports__)) {
    api.reload('49914f46', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=49914f46&scoped=true", () => {
    api.rerender('49914f46', render)
  })

}


export default __exports__